import { render, staticRenderFns } from "./WishListCard.vue?vue&type=template&id=559fa36e&scoped=true&"
import script from "./WishListCard.vue?vue&type=script&lang=js&"
export * from "./WishListCard.vue?vue&type=script&lang=js&"
import style0 from "./WishListCard.vue?vue&type=style&index=0&id=559fa36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559fa36e",
  null
  
)

export default component.exports